/*
 * @Author: etong
 * @Date: 2021-07-15 11:43:53
 * @LastEditTime: 2021-07-15 11:45:13
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\components\JJVisNetwork\index.js
 * Think first, Program later
 */
import Vue from 'vue'
import Content from './content.vue'
Vue.component('JJVisNetwork', Content)
